import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "positionFilled"
const PositionFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 9.938C13.14 9.938 14.063 10.86 14.063 12 14.063 13.14 13.139 14.063 12 14.063S9.938 13.139 9.938 12 10.86 9.938 12 9.938" />
          <path
            fillRule="evenodd"
            d="M12 1.313C12.518 1.313 12.938 1.733 12.938 2.25V4.371C16.433 4.796 19.202 7.565 19.628 11.06H21.754C22.272 11.059 22.69 11.479 22.69 11.996S22.271 12.934 21.754 12.934H19.629C19.205 16.432 16.435 19.203 12.938 19.628V21.75C12.938 22.268 12.518 22.688 12 22.688S11.063 22.268 11.063 21.75V19.628C7.566 19.203 4.795 16.431 4.37 12.934H2.254C1.736 12.934 1.316 12.514 1.316 11.996 1.316 11.48 1.736 11.06 2.254 11.06H4.372C4.8 7.565 7.568 4.796 11.062 4.37V2.25C11.063 1.732 11.483 1.313 12 1.313M12 6.188C8.807 6.188 6.215 8.763 6.188 11.95Q6.19 11.973 6.191 11.996L6.188 12.044C6.212 15.234 8.805 17.812 12 17.812 15.21 17.813 17.813 15.21 17.813 12S15.21 6.188 12 6.188"
            clipRule="evenodd"
          />
          <path d="M12 9.938C13.14 9.938 14.063 10.86 14.063 12 14.063 13.14 13.139 14.063 12 14.063S9.938 13.139 9.938 12 10.86 9.938 12 9.938" />
          <path
            fillRule="evenodd"
            d="M12 1.313C12.518 1.313 12.938 1.733 12.938 2.25V4.371C16.433 4.796 19.202 7.565 19.628 11.06H21.754C22.272 11.059 22.69 11.479 22.69 11.996S22.271 12.934 21.754 12.934H19.629C19.205 16.432 16.435 19.203 12.938 19.628V21.75C12.938 22.268 12.518 22.688 12 22.688S11.063 22.268 11.063 21.75V19.628C7.566 19.203 4.795 16.431 4.37 12.934H2.254C1.736 12.934 1.316 12.514 1.316 11.996 1.316 11.48 1.736 11.06 2.254 11.06H4.372C4.8 7.565 7.568 4.796 11.062 4.37V2.25C11.063 1.732 11.483 1.313 12 1.313M12 6.188C8.807 6.188 6.215 8.763 6.188 11.95Q6.19 11.973 6.191 11.996L6.188 12.044C6.212 15.234 8.805 17.812 12 17.812 15.21 17.813 17.813 15.21 17.813 12S15.21 6.188 12 6.188"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PositionFilledIcon
